import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const TwoFAOutlineIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "TwoFAOutline",
    children: /*#__PURE__*/_jsx("path", {
      d: "M21.26 12.15c-.21-.22-.51-.35-.83-.35s-.62.13-.83.35l-5.25 5.25-1.99-1.99c-.21-.22-.51-.35-.83-.35s-.62.13-.83.35c-.21.21-.34.5-.34.82 0 .33.13.62.34.83l2.83 2.83c.21.21.49.34.81.34h.08c.32 0 .61-.13.82-.34l6.05-6.05c.21-.21.35-.51.35-.83s-.14-.63-.36-.85Zm-5.27-7.09 8.75 4.75c-.13 5.13-1.15 9.04-3.1 11.91a19 19 0 0 1-5.57 5.07l-.09.05a18.8 18.8 0 0 1-5.61-5.06l-.04-.05c-1.95-2.87-2.97-6.77-3.1-11.91l8.75-4.75Zm0-3.06c-.16 0-.31.05-.44.12L4.9 7.9c-.28.16-.47.46-.48.8 0 6.94 1.44 11.43 3.6 14.6 2.15 3.17 4.96 4.94 7.48 6.55.14.09.31.15.49.15.19 0 .36-.06.5-.15 2.52-1.61 5.32-3.36 7.5-6.55s3.6-7.66 3.6-14.6v-.03c0-.34-.19-.63-.47-.77S16.44 2.12 16.44 2.12a.9.9 0 0 0-.44-.11Z"
    })
  }));
};